import React, {
	createContext,
	useRef,
	useCallback,
	ReactNode,
	MutableRefObject,
	useState,
} from 'react';
import { FormikProps } from 'formik';

interface FormikRefsContextType {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	formikRefs: { [key: string]: MutableRefObject<FormikProps<any> | null> };
	registerRef: (
		key: string,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		ref: MutableRefObject<FormikProps<any> | null>,
	) => void;
	unregisterRef: (key: string) => void;
	updateRefs: () => void;
}

export const FormikRefsContext = createContext<
	FormikRefsContextType | undefined
>(undefined);

export const FormikRefsProvider: React.FC<{ children: ReactNode }> = ({
	children,
}) => {
	const [update, setUpdate] = useState(false);
	//This holds all the formiks refs defined in the application if and only if they are registered.
	const formikRefs = useRef<{
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		[key: string]: MutableRefObject<FormikProps<any> | null>;
	}>({});

	//Adding the new formikref.
	const registerRef = useCallback(
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(key: string, ref: MutableRefObject<FormikProps<any> | null>) => {
			formikRefs.current[key] = ref;
		},
		[],
	);
	//Removing or deleting specific formikref.
	const unregisterRef = useCallback((key: string) => {
		delete formikRefs.current[key];
	}, []);

	const updateRefs = () => {
		setUpdate(!update);
	};

	return (
		<FormikRefsContext.Provider
			value={{
				formikRefs: formikRefs.current,
				registerRef,
				unregisterRef,
				updateRefs,
			}}
		>
			{children}
		</FormikRefsContext.Provider>
	);
};
